import { useState } from "react";
import dayjs from "dayjs";
import { Button, Input, Table, Flex } from "antd";
import MenuActions from "../../../../../../../../../../atom/MenuActions";

const TabAdvisors = ({
  disableEdit,
  handleActionArchive,
  handleActionEdit,
  handleActionTransfer,
  handleButtonNewAdvisor,
  handleOpenManagedUser,
  handleUserNameClick,
  isDisabledAdvisorResetPassword,
  listUsers,
  loading,
}) => {
  const [searchedText, setSearchedText] = useState("");

  const columns = [
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(`${record.firstName} ${record.lastName}`)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
        String(record.email).toLowerCase().includes(value.toLowerCase()),
      render: allValues => (
        <Flex vertical>
          <a
            onClick={() =>
              handleUserNameClick({
                activeEmail: allValues.email,
                activeSection: "advisor",
              })
            }
          >
            {allValues.firstName} {allValues.lastName}
          </a>
          <a
            href={`mailto:${allValues.email}`}
            style={{ color: "#4B4747", fontSize: 12 }}
          >
            {allValues.email}
          </a>
        </Flex>
      ),
      sorter: (a, b) => a.email.localeCompare(b.email),
      title: "Name",
    },
    {
      render: () => "N/A",
      title: "Organization",
    },
    {
      className: "cell-accent",
      align: "right",
      render: allValues =>
        allValues.userManager?.lastLoginTime?.$date
          ? dayjs(allValues.userManager.lastLoginTime.$date).format(
              "MM/DD/YY, h:mma"
            )
          : "N/A",
      sorter: (a, b) =>
        dayjs(a.userManager?.lastLoginTime?.$date) -
        dayjs(b.userManager?.lastLoginTime?.$date),
      title: "Last Login",
    },
    {
      className: "actions-menu-table-cell",
      render: allValues => (
        <MenuActions
          items={[
            {
              disabled: disableEdit,
              label: "Edit User",
              onClick: () => handleActionEdit(allValues.email),
            },
            {
              label: "Open Advisor View",
              onClick: () => handleOpenManagedUser(allValues.email),
            },
            {
              disabled: disableEdit || isDisabledAdvisorResetPassword,
              label: "Reset Password",
              onClick: () => console.log("TBD"),
            },
            {
              disabled: true,
              // disabled: disableEdit,
              key: "transfer",
              label: "Transfer Client/Leads",
              onClick: () => handleActionTransfer(allValues.email),
            },
            {
              disabled: disableEdit,
              key: "archive",
              label: "Archive User",
              onClick: () => handleActionArchive(allValues.email),
            },
          ]}
        />
      ),
      width: 40,
    },
  ];

  return (
    <Flex gap={24} vertical>
      <Flex justify="space-between">
        <Input
          style={{
            maxWidth: 200,
            height: 37,
            borderRadius: 25,
          }}
          placeholder="Search..."
          onChange={event => setSearchedText(event.target.value)}
        />

        <Flex gap={16}>
          <Button shape="round" style={{ color: "#052C2B" }} type="text">
            Bulk Load
          </Button>
          <Button
            disabled={loading || disableEdit}
            onClick={handleButtonNewAdvisor}
            shape="round"
          >
            New Advisor
          </Button>
        </Flex>
      </Flex>

      <Table
        columns={columns}
        dataSource={listUsers?.map(it => ({
          ...it,
          key: it.email,
        }))}
        loading={loading}
        pagination={false}
        rowHoverable={false}
        size="small"
      />
    </Flex>
  );
};

export default TabAdvisors;
